import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/my_img_bg.jpeg";
import Typewriter from "typewriter-effect";
import Section2 from "./Section2";
import StarsCanvas from "../Stars";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <StarsCanvas />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi Stars!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> TEEKAM SINGH</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                {/* <Type /> */}
                <Typewriter
                  options={{
                    strings: [
                      "Software Engineer",
                      "MERN Stack Developer",
                      "Web Developer",
                      // "Open Source Contributor",
                    ],
                    autoStart: true,
                    loop: true,
                    deleteSpeed: 50,
                  }}
                />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20, textAlign:"center" }} >
              <img
                // src="./my_image.jpg"
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px", borderRadius: "20%" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Section2 />
    </section>
  );
}

export default Home;
